import { render, staticRenderFns } from "./ComplainOrder.vue?vue&type=template&id=1a857e87&scoped=true"
import script from "./ComplainOrder.vue?vue&type=script&lang=ts"
export * from "./ComplainOrder.vue?vue&type=script&lang=ts"
import style0 from "./ComplainOrder.vue?vue&type=style&index=0&id=1a857e87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a857e87",
  null
  
)

export default component.exports